<template>
    <div class="doc-grid flex flex-col border-box">

        <div v-for="item in fileData" class="file-box position-relative">
            <div class="pointer dir-box" @click="gridItemClick(item.id)"  >
                <img v-if="item.cover != null && item.cover != ''" class="file-img" :src="item.cover"/>
                <div v-if="item.cover == null || item.cover == ''" class="file-img padding-s font-s border-box">{{item.summary}}</div>
            </div>
            <div class="file-desc">
                <div class="file-left">
                    <div class="file-name">{{item.name}}</div>
                    <div class="flex flex-row file-remark">
                    <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{item.likeCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{item.viewCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{item.commentCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{item.collectCount}}</div></div>
                    </div>
                </div>
                <div class="file-right">
                    <div class="file-share pointer" @click="share(item)"><img class="share-img" src="@/assets/images/share.png"/></div>
                </div>
            </div>          
        </div>

    </div>
</template>

<script>
    import PopupMenu from '@/components/popupMenu/PopupMenu' 
    import Share from '@/modules/share/Share'
    import Move from '@/modules/move/Move'
        
    export default{
        name:'DocGridA',
        components:{
            PopupMenu,Share,Move
        },
        props:{
            fileData:{}
        },
        data() {
            return {

            }
        },
        methods:{

            gridItemClick(id) {
                this.$router.push({
                  path: '/doc',
                  query: {
                    id: id 
                  }
              })
            },  

        }
    }
</script>

<style scoped>

    .file-right{
        width: 35px;
    }

    .dir-box {
        overflow: hidden;
        height: 170px;
    }
  

</style>


// WEBPACK FOOTER //
// src/modules/doc/DocGridA.vue